var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOnDemandPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5834 18.7917H6.41671C3.66671 18.7917 1.83337 17.4167 1.83337 14.2083V7.79167C1.83337 4.58334 3.66671 3.20834 6.41671 3.20834H15.5834C18.3334 3.20834 20.1667 4.58334 20.1667 7.79167V14.2083C20.1667 17.4167 18.3334 18.7917 15.5834 18.7917Z",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.04163 8.70834V13.2917",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.9584 8.70834V13.2917",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnDemandPay);
export default __webpack_public_path__ + "static/media/icon-on-demand-pay.04ec2a48.svg";
export { ForwardRef as ReactComponent };